import React from 'react';
import styles from '../../styles/flyouts/tasks/Timesheets.scss';
import {
  __,
  convertMinutesToHoursAndMinutes,
  dateFrom,
} from '../../core/utils';
import { subscribe } from 'react-contextual';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import Tooltip from '../../components/Tooltip';
import classNames from 'classnames';
import EditIcon from '../../assets/images/edit-16x16.svg';
import Localization from '../../helpers/Localization';
import Avatar from '../../components/Avatar';

const Timesheets = (props) => {
  const { collapsed, data } = props;
  const { is_editor } = data;
  const timeSummary = data.time_summary || {};
  const timeLog = data.time_log || {};

  return (
    <div className={classNames(styles.wrapper, collapsed && styles.collapsed)}>
      {!_.isEmpty(data.time_entries) && (
        <div className={styles.summary}>
          <div className={styles.summaryCard}>
            <span className={styles.summaryLabel}>
              {__('tasks.flyout.timesheet.estimate')}
            </span>
            <span className={styles.summaryValue}>
              {timeSummary?.estimated_time}
            </span>
          </div>
          <div className={styles.summaryCard}>
            <span className={styles.summaryLabel}>
              {__('tasks.flyout.timesheet.logged')}
            </span>
            <span className={styles.summaryValue}>
              {timeSummary?.logged_time}
            </span>
          </div>
          <div className={styles.summaryCard}>
            <span className={styles.summaryLabel}>
              {__('tasks.flyout.timesheet.is-billable')}
            </span>
            <span
              className={classNames(styles.summaryValue, styles.summaryBillable)}
            >
              {timeSummary?.billable_time}
            </span>
          </div>
          <div className={styles.summaryCard}>
            <span className={styles.summaryLabel}>
              {__('tasks.flyout.timesheet.non-billable')}
            </span>
            <span
              className={classNames(
                styles.summaryValue,
                styles.summaryNonBillable
              )}
            >
              {timeSummary?.non_billable_time}
            </span>
          </div>
          <div className={styles.summaryCard}>
            <span className={styles.summaryLabel}>
              {__('tasks.flyout.timesheet.remaining')}
            </span>
            <span className={styles.summaryValue}>
              {timeSummary?.remaining_time}
            </span>
          </div>
        </div>
      )}
      {!_.isEmpty(data.time_entries) &&
        is_editor &&
        !_.includes(['closed', 'canceled'], data.status) && (
          <div className={styles.heading}>
            <span className={styles.order}>
              <Tooltip
                text={__('tasks.all-tasks.flyout.add-timesheet-item.order')}
              >
                <span className={styles.tooltip}>{'#'}</span>
              </Tooltip>
            </span>
            <span className={styles.description}>
              <Tooltip
                text={__(
                  'tasks.all-tasks.flyout.add-timesheet-item.description'
                )}
              >
                <span className={styles.tooltip}>
                  {__('tasks.all-tasks.flyout.add-timesheet-item.description')}
                </span>
              </Tooltip>
            </span>
            <span className={styles.user}>
              <Tooltip
                text={__('tasks.all-tasks.flyout.add-timesheet-item.user')}
              >
                <span className={styles.tooltip}>
                  {__('tasks.all-tasks.flyout.add-timesheet-item.user')}
                </span>
              </Tooltip>
            </span>
            <span className={styles.date}>
              <Tooltip
                text={__('tasks.all-tasks.flyout.add-timesheet-item.date')}
              >
                <span className={styles.tooltip}>
                  {__('tasks.all-tasks.flyout.add-timesheet-item.date')}
                </span>
              </Tooltip>
            </span>
            <span className={styles.minutes}>
              <Tooltip
                text={__('tasks.all-tasks.flyout.add-timesheet-item.minutes')}
              >
                <span className={styles.tooltip}>
                  {__('tasks.all-tasks.flyout.add-timesheet-item.minutes')}
                </span>
              </Tooltip>
            </span>
            <span className={styles.billable}>
              <Tooltip text={__('table.columns.timesheet-is-billable')}>
                <span className={styles.tooltip}>
                  {__('table.columns.timesheet-is-billable')}
                </span>
              </Tooltip>
            </span>
            <span className={styles.location}>
              <Tooltip text={__('table.columns.timesheet-work-site')}>
                <span className={styles.tooltip}>
                  {__('table.columns.timesheet-work-site')}
                </span>
              </Tooltip>
            </span>
            {is_editor && !_.includes(['closed', 'canceled'], data.status) && (
              <span className={styles.edit} />
            )}
          </div>
        )}
      <div className={styles.scroller}>
        {!_.isEmpty(data.time_entries) &&
          _.map(data.time_entries, (row, i) => {
            const duration = convertMinutesToHoursAndMinutes(row.minutes, true);

            return (
              <div
                className={classNames(
                  styles.row,
                  row.completed_at && styles.blue
                )}
                key={row.id}
              >
                <span className={styles.order}>{i}</span>
                <Tooltip text={row.description}>
                  <span className={styles.description}>
                    {/* <span className={`${styles.description}`}> */}
                    {row.description}
                    {/* </span> */}
                  </span>
                </Tooltip>
                <span className={styles.user}>
                  <Avatar
                    avatar_url={row.user.avatar_url}
                    name={row.user.name}
                    active={row.user.active}
                    tooltip={true}
                  />
                </span>
                <span className={styles.date}>{dateFrom(row.date)}</span>
                <span className={styles.minutes}>{duration}</span>
                <span className={styles.billable}>
                  <input type='checkbox' checked={!!row.is_billable} readOnly />
                </span>
                <Tooltip text={row?.location?.name}>
                  <span className={styles.location}>
                    {row?.location?.name || ''}
                  </span>
                </Tooltip>
                {is_editor &&
                  !_.includes(['closed', 'canceled'], data.status) &&
                  (props.auth.id === row.user.id ? (
                    <span
                      className={styles.edit}
                      onClick={() =>
                        props.actions.setTableParams({
                          wizard_timesheet_edit: true,
                          task_id: data.id,
                          time_sheet_row: row,
                        })
                      }
                    >
                      <Tooltip
                        text={__('projects.tooltips.tasks.edit-timesheet')}
                      >
                        <EditIcon />
                      </Tooltip>
                    </span>
                  ) : (
                    <span className={styles.emptyEdit} />
                  ))}
              </div>
            );
          })}
      </div>
      {is_editor && !_.includes(['closed', 'canceled'], data.status) && (
        <div className={styles.addItem}>
          <button
            onClick={() =>
              props.actions.setTableParams({
                //wizard_active: true,
                wizard_timesheet_add: true,
                task_id: data.id,
              })
            }
          >
            {__('tasks.notification.timesheets.add')}
          </button>
        </div>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.timesheets/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(subscribe(Localization, 'localization')(Timesheets));
